import React, { useContext, useEffect } from 'react';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { RecsContext } from '../RecsContext';
import { dataModel } from './dataModel';

export const RecommendationsPlaceholder = (props) => {
  const context = useContext(RecsContext);
  const expContext = useContext(ExperienceContext);
  const {
    scheme,
    schema,
    itemId,
    hideRecommendation,
    defer
  } = props;
  const path = expContext?.path;
  const isServer = expContext?.isServer;
  const { channel } = expContext;

  useEffect(() => {
    const { addSchema } = context;
    if (addSchema) {
      addSchema(scheme || schema, defer);
    }
  }, [scheme, schema]);

  const shouldShowRecsHeader = () => {
    let showRecsHeader = false;
    if (/cm_mmc/.test(path)) {
      showRecsHeader = true;
    }

    useEffect(() => {
      if (!isServer) {
        showRecsHeader = /google\.com|bing\.com|yahoo\.com/.test(window.document.referrer);
      }
    }, [isServer]);
    return showRecsHeader;
  };

  const schemen = scheme || schema;
  const storeId = useStoreId();
  const { data, loading } = useProductDeprecated({
    itemId,
    storeId,
    domains: ['media'],
    skip: (schemen !== 'visuallysimilar_1_0' || !itemId || channel === 'mobile') && storeId === '8119',
    ssr: false
  });

  if (hideRecommendation && (schemen === 'pipsem' || schemen === 'pip_sem_mobile'
     || schemen === 'PIPHorizontal2_rr') && !shouldShowRecsHeader()) {
    return null;
  }

  useEffect(() => {
    if (data) {
      const { updateResx } = context;
      const primary = data.product?.media?.images?.find((img) => img.subType === 'PRIMARY');
      const index = primary?.sizes?.indexOf('400');
      if (index > -1) {
        const productImageURL = primary.url.replace('<SIZE>', '400');
        if (updateResx && productImageURL) {
          updateResx({ visSim: { productImageURL } });
        }
      }

    }
  }, [data]);

  return (
    <div id={schemen} />
  );
};

RecommendationsPlaceholder.displayName = 'RecommendationsPlaceholder';

RecommendationsPlaceholder.dataModel = dataModel;

RecommendationsPlaceholder.propTypes = {
  defer: PropTypes.bool,
  itemId: PropTypes.string,
  scheme: PropTypes.string.isRequired,
  schema: PropTypes.string,
  hideRecommendation: PropTypes.bool
};
RecommendationsPlaceholder.defaultProps = {
  defer: false,
  itemId: null,
  schema: null,
  hideRecommendation: false
};
